export var fleetGuardMenuItems = [
    {
        id: "fleetguard",
        label: "Fleet Guard",
        icon: "ri-truck-line",
        link: "/#",
        subItems: [
            { id: "fleetguard-dashboard", label: "Dashboard", icon: "ri-dashboard-3-line", link: "/fleetguard/dashboard", parentId: "fleetguard", permissionTypeId: [] },
            { id: "fleetguard-fleets", label: "Fleets Masterlist", icon: "ri-car-line", link: "/fleetguard/fleets", parentId: "fleetguard", permissionTypeId: [] },
            { id: "fleetguard-my-fleets", label: "My Fleets", icon: "ri-steering-2-line", link: "/fleetguard/my-fleets", parentId: "fleetguard", permissionTypeId: [] },
            { id: "fleetguard-vehicle-tracking", label: "Vehicle Tracking", icon: "ri-gps-line", link: "/fleetguard/vehicle-tracking", parentId: "fleetguard", permissionTypeId: [] },
            { id: "fleetguard-transactions", label: "Transactions", icon: "ri-refund-2-line", link: "/fleetguard/transactions", parentId: "fleetguard", permissionTypeId: [] },
            { id: "fleetguard-settings", label: "Settings", icon: "ri-tools-line", link: "/fleetguard/settings", parentId: "fleetguard", permissionTypeId: [] },
            { id: "fleetguard-reports", label: "Reports", icon: "ri-file-chart-line", link: "/fleetguard/reports", parentId: "fleetguard", permissionTypeId: [] },
        ],
    },
];